import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HomeRoutingModule } from './home-routing.module';
import {
  MatToolbarModule, MatButtonModule, MatSidenavModule, MatIconModule, MatCardModule, MatSnackBarModule,
  MatListModule, MatMenuModule, MatBadgeModule, MatFormFieldModule, MatInputModule, MatCheckboxModule,
  MatTableModule, MatTabsModule, MatPaginatorModule, MatSelectModule, MatDialogModule,MatSlideToggleModule
} from '@angular/material';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { DashboardComponent } from "./dashboard/dashboard.component";
import { SidenavComponent } from "./sidenav/sidenav.component";
import { ChartModule } from 'angular-highcharts';
import { HomeComponent } from "../home/home.component";
import { SummaryComponent } from './summary/summary.component';
import { AdminPanelComponent } from './admin-panel/admin-panel.component';
import { CategoryFunctinalitesComponent } from './category-functinalites/category-functinalites.component';
import { ProductFunctinalitesComponent } from './product-functinalites/product-functinalites.component';
import { SubProductFunctinalitesComponent } from './sub-product-functinalites/sub-product-functinalites.component';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { ConsumerComponent } from './consumer/consumer.component';
import { TransactionsComponent } from './transactions/transactions.component';
import { TransactiondetailsComponent } from './transactiondetails/transactiondetails.component';
import { UsersComponent } from './users/users.component';

@NgModule({
  declarations: [
    SidenavComponent,
    DashboardComponent,
    HomeComponent,
    SummaryComponent,
    AdminPanelComponent,
    CategoryFunctinalitesComponent,
    ProductFunctinalitesComponent,
    SubProductFunctinalitesComponent,
    ConsumerComponent,
    TransactionsComponent,
    TransactiondetailsComponent,
    UsersComponent
  ],
  imports: [
    CommonModule,
    HomeRoutingModule,
    MatToolbarModule,HttpClientModule,
    MatButtonModule,MatSlideToggleModule,
    MatSidenavModule, FormsModule, ReactiveFormsModule,
    MatIconModule, MatPaginatorModule, MatSelectModule, MatDialogModule,
    ChartModule, MatCardModule, MatSnackBarModule, MatListModule, MatMenuModule, MatTabsModule,
    MatBadgeModule, MatFormFieldModule, MatInputModule, MatCheckboxModule, MatTableModule,
  ]
})
export class HomeModule { }
